import { focusManager } from '@tanstack/react-query';
import { AppState, Platform } from 'react-native';
import type { AppStateStatus } from 'react-native';

let initialized = false;

function setupWebFocusManager(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  focusManager.setEventListener((handleFocus) => {
    const onVisibilityChange = (): void => {
      handleFocus(document.visibilityState === 'visible');
    };
    const onWindowFocus = (): void => {
      handleFocus(true);
    };
    const onWindowBlur = (): void => {
      handleFocus(false);
    };

    window.addEventListener('focus', onWindowFocus, false);
    window.addEventListener('blur', onWindowBlur, false);
    document.addEventListener('visibilitychange', onVisibilityChange, false);

    return () => {
      window.removeEventListener('focus', onWindowFocus);
      window.removeEventListener('blur', onWindowBlur);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  });

  focusManager.setFocused(document.visibilityState === 'visible');
}

function setupNativeFocusManager(): void {
  const onAppStateChange = (status: AppStateStatus): void => {
    focusManager.setFocused(status === 'active');
  };

  focusManager.setFocused(AppState.currentState === 'active');
  AppState.addEventListener('change', onAppStateChange);
}

/**
 * Wire platform lifecycle to TanStack Query's focusManager:
 * - Web / mobile web: window focus + Page Visibility (Safari/Chrome app switch)
 * - Native iOS / Android: AppState active/background
 */
export function setupReactQueryFocusManager(): void {
  if (initialized) {
    return;
  }
  initialized = true;

  if (Platform.OS === 'web') {
    setupWebFocusManager();
    return;
  }

  setupNativeFocusManager();
}
